import App from '@app/app.js';
import template from './lt-delivery-pill.html';
import { DELIVERY_TYPE_UTILS } from '@app/utils/ShippingTypeUtils';
import 'app/service/ShippingTypeService.js';
import '@app/components/core/lt-icon/lt-icon.component';

class LtDeliveryPillController {
  constructor(ShippingTypeService) {
    this.ShippingTypeService = ShippingTypeService;
    this.deliveryTypeConfig = DELIVERY_TYPE_UTILS;
  }

  get type() {
    return this.ShippingTypeService.getDeliveryType(this.subject);
  }
}

LtDeliveryPillController.$inject = ['ShippingTypeService'];

App.component('ltDeliveryPill', {
  template,
  bindings: {
    subject: '<'
  },
  controller: LtDeliveryPillController,
  controllerAs: 'ltDeliveryPill'
});
